import React from 'react'
import ComponentPay from '../ComponentPay'
import { Button, Pane } from 'evergreen-ui'

const StatusManageRegist_4 = ({ DataRegister }) => {

  // สร้างรายการปุ่มที่ต้องการแสดง
  const receiptButtons = [
    {
      label: "ใบเสร็จการชำระเงินงวดที่ 1",
      book: DataRegister[0].REGISTER_STATUS_BILL_ROB1_BOOK,
      no: DataRegister[0].REGISTER_STATUS_BILL_ROB1_NO,
      count: DataRegister[0].REGISTER_STATUS_BILL_ROB1_COUNT,
    },
    {
      label: "ใบเสร็จการชำระเงินงวดที่ 2",
      book: DataRegister[0].REGISTER_STATUS_BILL_ROB2_BOOK,
      no: DataRegister[0].REGISTER_STATUS_BILL_ROB2_NO,
      count: DataRegister[0].REGISTER_STATUS_BILL_ROB2_COUNT,
    },
    {
      label: "ใบเสร็จการชำระเงินเต็มจำนวน",
      book: DataRegister[0].REGISTER_STATUS_BILL_ROBFULL_BOOK,
      no: DataRegister[0].REGISTER_STATUS_BILL_ROBFULL_NO,
      count: DataRegister[0].REGISTER_STATUS_BILL_ROBFULL_COUNT,
    },
  ];

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: 10 }}>

      {/* {
        (DataRegister[0].Major1_MAJOR_ID === "9902" || DataRegister[0].Major1_MAJOR_ID === "9903") ?
          (
            <Button
              onClick={() => {
                window.open("https://admission.kpru.ac.th/admission2017/public/B/PN2569.pdf");
              }}
              intent="success"
            >
              แบบฟอร์มรายงานผลตรวจร่างกายของผู้มีสิทธิ์เข้าศึกษา
            </Button>
          ) : (<ComponentPay data={DataRegister} />)
      } */}

      {
        (DataRegister[0].ROB_ID !== "182" && DataRegister[0].ROB_ID !== "183" && DataRegister[0].ROB_ID !== "184") && (<ComponentPay data={DataRegister} />)
      }
      
      


      <Pane display="flex" flexDirection="column" gap={5}>
        {receiptButtons.map((item, index) => {
          if (!item.book) return null; // ถ้า book = null ไม่ต้องแสดงปุ่ม

          const bookNo = item.book.split("/")[1];

          return (
            <Button
              key={index}
              appearance="primary"
              intent="success"
              onClick={() => {
                window.open(
                  `https://e-finance.kpru.ac.th/printbill_admissionreportdownload?BOOK_YEAR=${DataRegister[0].ROB_YEAR}&BOOK_NO=${bookNo}&ID_NO=${DataRegister[0].REGISTER_ID}&NO=${item.no}&typeuser=2&countbill=${item.count}`
                );
              }}
            >
              {item.label}
            </Button>
          );
        })}
      </Pane>
    </div>
  )
}

export default StatusManageRegist_4